import { useParams as _useParams } from 'react-router';

function useParams() {
	return _useParams();
}

export default useParams;
